import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { combineLatest, Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { UserService } from '../services';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private userService: UserService,
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {

    const token$: Observable<string> = of('a5c5d34e95484dd095b0d3f4fd2154e8');

    return combineLatest([
      token$,
      this.userService.accessToken$,
    ]).pipe(
      take(1),
      switchMap(([token, accessToken]: string[]) => {
        if (token && req.url.includes(environment.apiUrl)) {
          req = req.clone({
            headers: req.headers.set('Ocp-Apim-Subscription-Key', token).set('Authorization', `Bearer ${accessToken}`),
          });
        }
        return next.handle(req);
      }),
    );
  }
}
